import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import _ from 'lodash';
import { getUserText, isEqualIds } from 'ziphy-web-shared/basic/helpers';
import { TabsBar } from 'ziphy-web-shared/basic/lib/functional';
import { $modal } from 'ziphy-web-shared/basic/lib/utilities/modals';
import { $windowSize } from 'ziphy-web-shared/basic/utils';
import { $router } from 'ziphy-web-shared/basic/utils/router';
import SelectModal from '@library/select/Select.modal';
import { routeActions } from '@config/routeActions';
const ApptPatientsSelector = ({ encounterId, appointment, patients, className }) => {
    var _a;
    const { t } = useTranslation();
    const selectedPatientId = (_a = Object.values(patients).find((x) => isEqualIds(x.activeEncounter, encounterId))) === null || _a === void 0 ? void 0 : _a.id;
    const preparedList = useMemo(() => {
        return _.sortBy(Object.values(patients), 'activeEncounter').map((x) => ({
            id: x.id,
            text: `${getUserText(x, ['fullName', 'genderShort'])} ${getUserText(x, ['yo'])}`,
        }));
    }, [patients]);
    const handleOnChange = useCallback((patientId) => {
        $router.executeAutoTarget(routeActions.APPT({
            appointmentId: appointment.id,
            encounterId: patients[patientId].activeEncounter,
        }));
    }, [patients, appointment.id]);
    return (_jsx(TabsBar, { mode: $windowSize.isMobileSize ? ['secondary-dark', 'sm'] : ['white-dark-outline', 'sm'], modeSelected: $windowSize.isMobileSize ? ['primary', 'sm'] : ['black', 'sm'], items: preparedList, value: selectedPatientId, onChange: handleOnChange, onOpenModal: () => {
            $modal.add(SelectModal, {
                title: t('label.patients'),
                items: preparedList,
                searchBar: true,
                searchMap: ['text'],
                allowUnselect: false,
                searchLabel: t('label.search_patient'),
                value: [selectedPatientId],
                onChange: (values) => handleOnChange(values[0]),
            });
        }, moreButtonText: 'label.all_patients', className: classNames(className) }));
};
export default observer(ApptPatientsSelector);
